/**************************************************
 * Nombre:       Tarjeta_Informacion
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";

const Tarjeta_Informacion = ({item, click, index}) => {

    return (
        <Grid
            onClick={() => click(item, index)}
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{borderBottom: 1, py: 1}}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontSize: 16, fontWeight: 600}}>{item.nombre}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontSize: 14, fontWeight: 300, lineHeight: 1.1}}>{item.descripcion}</Typography>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Informacion